import { Injectable } from '@angular/core';
import { DebitNoteEnhancedApiService } from '@cms/apis';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { exhaustMap, map } from 'rxjs';
import { DebitNoteAction } from '../actions';
import { FnWithCompany, WithCompany } from '@cms/backgrounds/switch-company';

@Injectable()
export class DebitNoteEffect {
  loadItem$ = createEffect(() => {
    return this._actions$.pipe(
      ofType(DebitNoteAction.loadItem),
      exhaustMap(action => {
        return this.fetch(action.id).pipe(map(item => DebitNoteAction.loadItemSuccess({ item })));
      })
    );
  });

  @FnWithCompany()
  fetch(id: number, @WithCompany() option: Record<string, any> = {}) {
    return this._apiService.get(id, option);
  }

  constructor(private _apiService: DebitNoteEnhancedApiService, private _actions$: Actions, private _store: Store) {}
}
